/**
 * Texland Custom JavaScript
 * Otimizado para performance e conversão
 */

// Performance monitoring
const performanceMonitor = {
  mark(name) {
    if (window.performance) {
      performance.mark(name);
    }
  },
  measure(name, startMark, endMark) {
    if (window.performance) {
      performance.measure(name, startMark, endMark);
    }
  }
};

// Inicialização otimizada
document.addEventListener('DOMContentLoaded', function() {
  performanceMonitor.mark('customJsStart');
  initializeEssentialFeatures();
});

// Carregar features essenciais primeiro
function initializeEssentialFeatures() {
  // Otimizar variantes de produto
  initializeVariantListener();
  
  // Otimizar carrinho (importante devido à taxa de 50% de abandono)
  initializeCartFeatures();
  
  // Carregar features não essenciais depois
  window.addEventListener('load', initializeNonEssentialFeatures);
}

// Listener otimizado para variantes
function initializeVariantListener() {
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    
    // Atualizar preço (importante pois atualizas quando fornecedores aumentam)
    updatePrice(variant);
    
    // Atualizar imagens profissionais
    updateProductImages(variant);
  });
}

// Otimização do carrinho
function initializeCartFeatures() {
  document.addEventListener('product:added', function(event) {
    const variant = event.detail.variant;
    const quantity = event.detail.quantity;
    
    // Analytics para abandono do carrinho
    trackCartAddition(variant, quantity);
    
    // Atualizar mini-carrinho de forma eficiente
    updateMiniCart();
  });
}

// Funções de suporte otimizadas
function updatePrice(variant) {
  if (!variant) return;
  
  // Atualização eficiente de preço
  const priceElement = document.querySelector('[data-product-price]');
  if (priceElement && variant.price) {
    priceElement.innerHTML = formatPrice(variant.price);
  }
}

function updateProductImages(variant) {
  if (!variant?.featured_image) return;
  
  // Lazy loading para imagens profissionais
  const image = new Image();
  image.onload = function() {
    document.querySelector('.product-image').src = this.src;
  };
  image.src = variant.featured_image.src;
}

function updateMiniCart() {
  // Atualizar carrinho de forma eficiente
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}

// Features não essenciais
function initializeNonEssentialFeatures() {
  // Carregar após página principal
  setTimeout(() => {
    initializeSocialFeatures();
    initializeReviewSystem();
  }, 3000);
}

// Analytics para abandono do carrinho
function trackCartAddition(variant, quantity) {
  if (window.ga) {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Cart',
      eventAction: 'Add',
      eventLabel: variant.sku,
      eventValue: quantity
    });
  }
}

// Formatação de preço
function formatPrice(price) {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(price/100);
}

// Marca final de performance
window.addEventListener('load', function() {
  performanceMonitor.mark('customJsEnd');
  performanceMonitor.measure('customJsTotal', 'customJsStart', 'customJsEnd');
});


